/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { Route } from "react-router-dom"
import Callback from "./screens/Callback"
import LoginLogout from "./components/Auth/LoginLogout"
import Organization from "./screens/Organization"
import PrivateRoute from "./components/UI/PrivateRoute"
import { SWRConfig } from "swr"
import { Global } from "@emotion/core"
import { Theme } from "./components/types"
import AppProvider from "./components/AppProvider"
import LandingScreen from "./screens/Landing"
import { CloudinaryContext } from "cloudinary-react"
import ByUsLogo from "./components/UI/ByUsLogo"
import mixpanel from "mixpanel-browser"
import { useEffect } from "react"
import NewsBanner from "./components/Banners/NewsBanner"

function App() {
    useEffect(() => {
        mixpanel.track("App Loaded")
    }, [])
    return (
        <AppProvider>
            <CloudinaryContext
                cloudName="ymir"
                uploadPreset={process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET}
            >
                <Global styles={styles.body} />
                <SWRConfig
                    value={{
                        errorRetryCount: 3,
                        revalidateOnFocus: false,
                        fetcher: (url: string, token?: string) =>
                            fetch(url, {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                },
                            }).then((res) => {
                                return res.json()
                            }),
                    }}
                >
                    <LoginLogout />

                    <NewsBanner />
                    <div css={styles.container}>
                        <Route
                            path="/"
                            exact
                            component={() => <LandingScreen />}
                        />
                        <Route path="/callback" component={Callback} />
                        <PrivateRoute path="/organization">
                            <Organization />
                        </PrivateRoute>
                    </div>
                    <Route path="/" exact>
                        <ByUsLogo />
                    </Route>
                </SWRConfig>
            </CloudinaryContext>
        </AppProvider>
    )
}

export default App

const styles = {
    body: (theme: Theme) => css`
        body {
            font-family: "Source Sans Pro", "sans-serif";
            background-color: ${theme.colors.grey[200]};
            margin: 0;
        }
        html,
        body {
            margin: 0;
            color: ${theme.palette.text.primary};
        }
    `,
    container: (theme: Theme) => css`
        width: 95%;
        margin: ${theme.spaces.smallScale.xl} auto 0 auto;
        background-color: #ffffff;
        padding: 10px;
        border-radius: ${theme.spaces.smallScale.xxs};
        @media (min-width: 58rem) {
            width: 56rem;
        }
    `,
}
